import {CardInfoContent} from '../../../../components/CardInfoGuide/CardInfoGuide'

const productClassificationInfo: CardInfoContent = {
  title: 'Informativo de Classificação',
  subtitle: 'Dados do Produto',
  items: [
    {
      label: 'Marca',
      description:
        'Selecione uma marca já cadastrada. Caso não encontre, realize o cadastro antes de continuar.',
    },
    {
      label: 'Unidade de Medida',
      description: 'Unidade utilizada para controle e venda do produto (ex: unidade, par, cm).',
    },
  ],
}

const productIdentificationInfo: CardInfoContent = {
  title: 'Informativo de Identificação',
  subtitle: 'Dados do Produto',
  items: [
    {
      label: 'Nome',
      description: 'Nome exibido para o cliente no webapp. Ex: Camiseta Básica Algodão.',
    },
    {
      label: 'Botão Propor nome',
      description:
        'Sugere automaticamente um nome para o produto com base nas informações preenchidas.',
    },
    {
      label: 'Código',
      description: 'Código interno do produto para identificação no sistema. Ex: 12345.',
    },
  ],
}

const productDescriptionInfo: CardInfoContent = {
  title: 'Informativo de Conteúdo',
  subtitle: 'Dados do Produto',
  items: [
    {
      label: 'Descrição',
      description:
        'Descrição exibida ao cliente no webapp com detalhes do produto. Dica: Utilize uma descrição clara e objetiva.',
    },
    {
      label: 'Botão Descrição Avançada com IA',
      description:
        'Gera automaticamente uma descrição mais completa utilizando inteligência artificial.',
    },
    {
      label: 'Especificação Técnica',
      description:
        'Informações técnicas detalhadas do produto. Ex: Material, composição, dimensões.',
    },
  ],
}

const productStatusInfo: CardInfoContent = {
  title: 'Informativo de Status',
  subtitle: 'Dados do Produto',
  items: [
    {
      label: 'Status',
      description:
        'Define se o produto estará disponível para venda. Produtos inativos não aparecem para o cliente no webapp.',
    },
    {
      label: 'Ordem',
      description:
        'Define a posição do produto na listagem do webapp (ex: 1 = 1º da lista de produtos). Ex: 1, 2, 3....',
    },
  ],
}

const productImageInfo: CardInfoContent = {
  title: 'Informativo de Imagem Principal',
  subtitle: 'Imagens do Produto',
  items: [
    {
      label: 'Imagem Principal',
      description: 'Imagem principal exibida no produto.',
    },
    {
      label: 'Botão Propor imagem',
      description: 'Gera automaticamente uma imagem para o produto utilizando IA.',
    },
  ],
}

const productGuideInfo: CardInfoContent = {
  title: 'Informativo de Guia de Medidas',
  subtitle: 'Guia de Medidas',
  items: [
    {
      label: 'Imagem do guia',
      description:
        'Imagem exibida ao cliente para auxiliar na escolha de tamanho do produto. Ex: imagem com tabela de medidas ou guia de tamanhos (P, M, G).',
    },
    {
      label: 'Botão Configurar Guia de Medidas',
      description: 'Permite configurar as medidas do produto (ex: P, M, G).',
    },
  ],
}

const productExtraImagesInfo: CardInfoContent = {
  title: 'Informativo de Imagens Adicionais',
  subtitle: 'Imagens Adicionais',
  items: [
    {
      label: 'Upload de imagens',
      description:
        'Adicione imagens extras de diferentes posições e detalhes para melhor visualização do produto.',
    },
  ],
}

const productVisibilityPeriodInfo: CardInfoContent = {
  title: 'Informativo de Período de Venda',
  subtitle: 'Data de Visualização para Venda',
  items: [
    {
      label: 'Data de início da venda',
      description:
        'Define a partir de quando o produto ficará disponível para venda. Dica: Deixe vazio se o produto deve estar sempre visível a partir da data de criação.',
    },
    {
      label: 'Data de término da venda',
      description:
        'Define até quando o produto ficará disponível para venda. Dica: Deixe vazio se o produto deve estar sempre visível sem limite de data.',
    },
  ],
}

const productGroupsInfo: CardInfoContent = {
  title: 'Informativo de Grupos de Clientes',
  subtitle: 'Grupos de clientes para o Produto',
  items: [
    {
      label: 'Seleção de grupos',
      description: 'Define quais grupos de clientes podem visualizar ou comprar este produto.',
    },
  ],
}

export {
  productClassificationInfo,
  productIdentificationInfo,
  productDescriptionInfo,
  productStatusInfo,
  productImageInfo,
  productGuideInfo,
  productExtraImagesInfo,
  productVisibilityPeriodInfo,
  productGroupsInfo,
}
